'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: none;\n  line-height: 1.15;\n  margin: 0;\n  padding: 0;\n'], ['\n  display: none;\n  line-height: 1.15;\n  margin: 0;\n  padding: 0;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  transition: all 0.4s ease;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  background: ', ';\n  border: 1px solid #f5f5f5;\n  border-radius: 2em;\n  cursor: pointer;\n  display: block;\n  outline: 0;\n  padding: 2px;\n  position: relative;\n  user-select: none;\n  ', ';\n  ', ';\n\n  &::after {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08);\n    transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n      right 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;\n    -webkit-box-sizing: initial;\n    background-color: #fff;\n    border-radius: 2em;\n    box-sizing: initial;\n    content: \'\';\n    display: block;\n    height: 100%;\n    left: ', ';\n    right: ', ';\n    position: relative;\n    width: 50%;\n  }\n\n  &:hover {\n    &::after {\n      will-change: padding;\n    }\n  }\n\n  &:active {\n    box-shadow: ', ';\n\n    &::after {\n      padding-right: 0.8em;\n      margin-left: ', ';\n    }\n  }\n'], ['\n  transition: all 0.4s ease;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  background: ', ';\n  border: 1px solid #f5f5f5;\n  border-radius: 2em;\n  cursor: pointer;\n  display: block;\n  outline: 0;\n  padding: 2px;\n  position: relative;\n  user-select: none;\n  ', ';\n  ', ';\n\n  &::after {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08);\n    transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n      right 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;\n    -webkit-box-sizing: initial;\n    background-color: #fff;\n    border-radius: 2em;\n    box-sizing: initial;\n    content: \'\';\n    display: block;\n    height: 100%;\n    left: ', ';\n    right: ', ';\n    position: relative;\n    width: 50%;\n  }\n\n  &:hover {\n    &::after {\n      will-change: padding;\n    }\n  }\n\n  &:active {\n    box-shadow: ', ';\n\n    &::after {\n      padding-right: 0.8em;\n      margin-left: ', ';\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

var _WithDisplayName = require('../WithDisplayName');

var _WithDisplayName2 = _interopRequireDefault(_WithDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var SwitchContainer = _styledComponents2.default.span(_templateObject);

var Switch = _styledComponents2.default.input(_templateObject2);

var SwitchLabel = _styledComponents2.default.label(_templateObject3, function (props) {
  return props.isChecked ? '#3e8ddd' : '#e0e0e0';
}, _styledSystem.width, _styledSystem.height, function (props) {
  return props.isChecked && !props.reverse ? '50%' : '0';
}, function (props) {
  return props.isChecked && props.reverse ? '50%' : '0';
}, function (props) {
  return props.isChecked ? 'none' : 'inset 0 0 0 2em $light-grey';
}, function (props) {
  return props.isChecked ? '-0.8em' : 'none';
});

var SwitchButton = function (_Component) {
  _inherits(SwitchButton, _Component);

  function SwitchButton(props) {
    _classCallCheck(this, SwitchButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onClick = function () {
      var isChecked = !_this.state.isChecked;

      _this.setState({
        isChecked: isChecked
      });

      if (_this.props.onChange) {
        _this.props.onChange(isChecked);
      }
    };

    _this.getCheckValue = function () {
      return _this.state.isChecked;
    };

    _this.state = {
      isChecked: props.isChecked
    };
    return _this;
  }

  SwitchButton.prototype.componentDidMount = function componentDidMount() {
    if (this.props.isChecked) {
      document.getElementById(this.props.htmlFor).checked = true;
    } else {
      document.getElementById(this.props.htmlFor).checked = false;
    }
  };

  SwitchButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.isChecked !== nextProps.isChecked) {
      this.setState({ isChecked: nextProps.isChecked });
    }
  };

  SwitchButton.prototype.render = function render() {
    var isChecked = this.state.isChecked;
    var _props = this.props,
        disable = _props.disable,
        htmlFor = _props.htmlFor,
        className = _props.className,
        reverse = _props.reverse;

    return _react2.default.createElement(
      SwitchContainer,
      {
        className: (0, _classnames2.default)(className, {
          disabled: disable
        })
      },
      _react2.default.createElement(Switch, {
        className: (0, _classnames2.default)('switch-animation', {
          'switch-checked': isChecked
        }),
        id: htmlFor,
        type: 'checkbox'
      }),
      _react2.default.createElement(SwitchLabel, {
        onClick: this.onClick,
        onKeyPress: this.onClick,
        htmlFor: htmlFor,
        isChecked: isChecked,
        width: this.props.width,
        height: this.props.height,
        reverse: reverse
      })
    );
  };

  return SwitchButton;
}(_react.Component);

SwitchButton.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  isChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  htmlFor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  disable: _propTypes2.default.bool,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  reverse: _propTypes2.default.bool
} : {};

SwitchButton.defaultProps = {
  className: '',
  isChecked: true,
  disable: false,
  onChange: function onChange() {},
  width: '4em',
  height: '2em',
  reverse: false
};

exports.default = (0, _WithDisplayName2.default)(SwitchButton, 'SwitchButton');
module.exports = exports['default'];